/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PendingCCTokenStatusEnum {
    PENDING = 'Pending',
    CREATED = 'Created',
    FAILED = 'Failed',
}